import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import ClaimedDomainDetailsTabGeneral from './claimed-domain-details-tab-general';

import { fetchDomainNotes } from '../common/actions/domain-notes-action-creators';

import { claimedDomainsDetailsPaneSelector } from './selectors/domain-details-selectors';
import { domainNotesSelector } from '../common/selectors/domain-notes-selectors';

export class ClaimedDomainDetailsContentContainer extends Component{
    componentDidMount(){
        const { domainData } = this.props;
        this.fetchData( domainData.domainName );
    }

    componentDidUpdate( prevProps ){
        const {
            domainData: { domainName } = {}
        } = this.props;

        if( get( prevProps, 'domainData.domainName' ) !== domainName ){
            this.fetchData(  domainName );
        }
    }

    fetchData( domainName ){
        const { fetchDomainNotes } = this.props;

        fetchDomainNotes( domainName );
    }

    render(){
        const { domainData, domainNotesData, tabIndex } = this.props;
        const tabContent = [
            <ClaimedDomainDetailsTabGeneral domainData={domainData} domainNotesData={domainNotesData} />
        ];

        return tabContent[tabIndex];
    }
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => ( {
    domainData: claimedDomainsDetailsPaneSelector( state ),
    domainNotesData: domainNotesSelector( state ),
} );

ClaimedDomainDetailsContentContainer.propTypes = {
    domainData: PropTypes.shape( {
        actionsCount: PropTypes.number,
        authorizedMailVolume: PropTypes.number,
        dkimAlignRate: PropTypes.string,
        dkimPassAlignRate: PropTypes.string,
        dkimPassRate: PropTypes.string,
        dmarcDoublePassRate: PropTypes.string,
        dmarcPassRate: PropTypes.string,
        dmarcPolicy: PropTypes.string,
        domainCount: PropTypes.number,
        domainName: PropTypes.string.isRequired,
        domainType: PropTypes.string,
        orgDomain: PropTypes.string,
        percentBlocked: PropTypes.string,
        spfAlignRate: PropTypes.string,
        spfPassAlignRate: PropTypes.string,
        spfPassRate: PropTypes.string,
    } ),
    domainNotesData: PropTypes.array,
    fetchDomainNotes: PropTypes.func.isRequired,
    tabIndex: PropTypes.number.isRequired
};

export default connect( mapStateToProps, { fetchDomainNotes } )( ClaimedDomainDetailsContentContainer );
